/**
 * Legacy /dashboard/team route — now a router-side redirect.
 *
 * Brokers and individuals don't have a team and should never see a team page.
 * Companies have the real implementation at /company/team (with backend
 * integration via /api/companies/my/team). This page used to render a
 * hardcoded mock team that leaked into every account.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCompany } from '../../../hooks/useCompany';

export default function TeamPage() {
  const navigate = useNavigate();
  const { company, isLoading } = useCompany();

  useEffect(() => {
    if (isLoading) return;
    navigate(company ? '/company/team' : '/dashboard', { replace: true });
  }, [company, isLoading, navigate]);

  return null;
}
